<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="'/race_series/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <h5>オーダーIDとアクセスIDでデータ確認</h5>
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">オーダーID</p>
          </div>
          <div class="col-4 mb-2">
            <div class="input-group">
              <input
                type="text"
                v-model="sprm.order_id_s"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">アクセスID</p>
          </div>
          <div class="col-4 mb-2">
            <div class="input-group">
              <input
                type="text"
                v-model="sprm.access_id_s"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-10 offset-1">
            <p class="alert alert-info">
              {{ gmo_payment_data }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button
              :btnClass="'btn-primary'"
              @to_click_event="singleGmoCheck()"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>

    <h5>検索</h5>
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-3 mb-2">
            <p class="text-center py-1 fs-6">オーダーID</p>
          </div>
          <div class="col-6 mb-2">
            <div class="input-group">
              <textarea v-model="sprm.order_id" class="form-control" />
              <!-- <input type="text" v-model="sprm.order_id" class="form-control" /> -->
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-10 offset-1">
            <p class="alert alert-info">
              {{ gmo_payment_data }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button
              :btnClass="'btn-primary'"
              @to_click_event="search_sales()"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- {{ sales_list }} -->
    <div
      class="w100"
      v-if="
        typeof sales_list === 'object' && Object.keys(sales_list).length > 0
      "
    >
      <table class="table table-bordered">
        <thead class="text-center">
          <tr>
            <th>ライセンスNo</th>
            <th>会員</th>
            <th>状況</th>
            <th>種別</th>
            <th>支払種別</th>
            <th>請求額</th>
            <th>支払額</th>
            <th>注文ID</th>
            <th>-</th>
            <th>-</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in sales_list" :key="list.id">
            <td
              :class="
                list_check_class(
                  list.charge_type,
                  list.charge_access_id,
                  list.app_data.application_check_type,
                  list.cash_status
                )
              "
            >
              {{ list?.app_data?.license_no }}
            </td>
            <td>{{ list?.app_data?.name_1 }}{{ list?.app_data?.name_2 }}</td>
            <td>{{ list?.app_data?.application_check_type }}</td>
            <td>{{ list?.app_data?.application_type }}</td>
            <td>{{ list?.charge_type }}</td>
            <td>{{ list?.amount }}</td>
            <td>{{ list?.payment_value }}</td>
            <td>
              <div>{{ list?.charge_order_id }}</div>
              <input
                type="text"
                class="form-conrol form-control-sm"
                v-model="list.charge_access_id"
              />
            </td>
            <td>
              <button
                @click="handleClick(list.application_id)"
                class="btn btn-sm btn-light btn-outline-secondary"
              >
                申請確認</button
              ><br />
              {{ list.application_id }}
            </td>
            <td>
              <button
                @click="
                  getGmoCheck(list.charge_order_id, list.charge_access_id)
                "
                class="btn btn-sm btn-light btn-outline-secondary"
              >
                GMO確認
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../../../common/common'
// import BsSelect from '../../atoms/BsSelect.vue'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'CategoryListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '売上確認',
      fromParentBtn: '',
      sales_list_obj: [],
      sprm: {
        sel_year: '',
        sel_mon: '',
        sel_day: '',
        license_event_cd: '',
        license_class: '',
        license_category: '',
        order_id: '',
        access_id_s: '',
        order_id_s: ''
      },
      gmo_payment_data: {},
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert
    // BsSelect
  },
  computed: {
    ...mapState({}),
    list_check_class: function () {
      return function (
        charge_type,
        charge_access_id,
        application_check_type,
        cash_status
      ) {
        if (charge_type == 'KONBINI') {
          return cash_status === 'PAYSUCCESS' &&
            parseInt(application_check_type) < 426
            ? 'bg-warning'
            : (cash_status == 'REQSUCCESS' ||
                cash_status == 'UNPROCESSED' ||
                !cash_status) &&
              parseInt(application_check_type) >= 426
            ? 'bg-danger'
            : ''
        } else if (charge_type == 'CREDIT') {
          return !charge_access_id &&
            parseInt(application_check_type) >= 430 &&
            parseInt(application_check_type) != 600
            ? 'bg-warning'
            : charge_access_id &&
              parseInt(application_check_type) < 423 &&
              parseInt(application_check_type) > 200 &&
              parseInt(application_check_type) != 600
            ? 'bg-danger'
            : ''
        }
      }
    },
    sales_list: function () {
      return this.sales_list_obj
    }
  },

  async created() {
    // await this.loadLicenseClassList()
    // await this.loadLicenseCategoryList()
    // await this.loadLicenseEventCdList()
    // await this.loadRaceSeriesList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = 'エラー確認'
  },

  methods: {
    async singleGmoCheck() {
      this.isLoading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        await this.getGmoCheck(this.sprm.order_id_s, this.sprm.access_id_s)
      } finally {
        this.isLoading = false
      }
    },
    async getGmoCheck(orderId, accessId) {
      if (!orderId || !accessId) {
        alert('情報が保存されていません。GMOの管理画面で確認してください')
      }
      const params = {
        orderId: orderId,
        accessId: accessId
      }
      console.log('loadRaceSeriesList params', params)
      await this.basicPosts_S(config.BASE_API_URL + '/sales/gmo_check', params)
        .then(async response => {
          console.log('loadSalesData response', response)
          this.gmo_payment_data =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.gmo_payment_data = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async search_sales() {
      this.isLoading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        await this.loadSalesData()
      } finally {
        this.isLoading = false
      }
    },
    async loadSalesData() {
      if (!this.sprm.order_id) {
        alert('オーダーIDは必須です')
      }
      const params = {}
      const order_ids = this.sprm.order_id
        .split('\n')
        .filter(line => line.trim() !== '')
      if (Array.isArray(order_ids) && order_ids.length > 1) {
        params.charge_order_ids = order_ids
      } else if (Array.isArray(order_ids) && order_ids.length == 1) {
        params.charge_order_id = this.sprm.order_id
      }
      console.log('loadRaceSeriesList params', params)
      await this.basicPosts_S(
        config.BASE_API_URL + '/sales/error_check',
        params
      )
        .then(async response => {
          console.log('loadSalesData response', response)
          this.sales_list_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.sales_list_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },

    handleClick(target) {
      // this.$router.push({ path: '/application/' + target + '/' })
      const routeData = this.$router.resolve({
        path: '/application/' + target + '/'
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
